/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RuleSetStepperDrawer.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
"use strict";

import { Box, Stepper, Step, StepLabel } from "@mui/material";

const steps = ["Basic details", "Legal scope", "Workflow"];

export default function RuleSetStepperDrawer({ activeStep }) {
  return (
    <Box
      sx={{
        width: 260,
        borderRight: "1px solid #e0e0e0",
        py: 3,
        px: 2,
        fontFamily: "Open Sans, sans-serif",
      }}
    >
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        sx={{
          "& .MuiStepConnector-line": {
            borderColor: "#cfcfcf",
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              sx={{
                "& .MuiStepLabel-label": {
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: "14px",
                  fontWeight: index === activeStep ? 600 : 400,
                  color: index === activeStep ? "#26890D" : "#000000",
                },
                "& .MuiStepIcon-root": {
                  color: "#cfcfcf",
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "#26890D",
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "#26890D",
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
